var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, Watch, PropertyConverters, Utils } from './_default-imports';
//namespace Pacem.Components {
let PacemIfElement = class PacemIfElement extends HTMLElement {
    #innerHTML;
    propertyChangedCallback(name, old, val, first) {
        // setup lazily
        if (Utils.isNullOrEmpty(this.#innerHTML)) {
            this.#innerHTML = this.innerHTML;
        }
        if (!val) {
            this.innerHTML = '';
        }
        else {
            this.innerHTML = this.#innerHTML;
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemIfElement.prototype, "match", void 0);
PacemIfElement = __decorate([
    CustomElement({ tagName: P + '-if' })
], PacemIfElement);
export { PacemIfElement };
//}
